var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'inviteStatusContiner',
    { autoAlign: _vm.autoAlign, largePaddingTop: _vm.showPhoneNumber }
  ]},_vm._l((_vm.inviteList),function(item,index){return _c('div',{key:item.id,class:['inviteSlot', _vm.size, _vm.gapSize],style:(_vm.avatarStyle(item.avatar)),on:{"click":function($event){return _vm.handleClick(index, item.isInvited ? 'avatar' : 'add')}}},[(index === _vm.showPhoneNumberIndex)?_c('div',{staticClass:"floatPhoneNumber"},[_vm._v("\n      "+_vm._s(item.phoneNumber)+"\n    ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }